import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const salesTargetFilterTodo = createAsyncThunk('salesTargetFilter', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'sales-target-category',
            params: {
                'financialYear': data?.financial_year,
                'salesPersonId': data?.sales_person,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const salesTargetFilterSlice = createSlice({
    name: 'salesTargetFilter',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(salesTargetFilterTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(salesTargetFilterTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default salesTargetFilterSlice.reducer;